import { bootstrap } from "../imports";
import { changeURLSearchParam } from "../urls";
import { currentState } from "../config";

let vizSelectors = [];
let carousel = null;
const vizSlides = document.querySelectorAll(".viz-item");
const vizSelector = document.getElementById("vizSelector");
const vizSelectorTitle = document.getElementById("vizSelectorTitle");

export default function makeCarousel() {
  // Setting up Carousel

  const carouselElement = document.querySelector("#carouselViz");

  carousel = new bootstrap.Carousel(carouselElement, {
    interval: 2000,
    touch: false,
  });

  let initialTitle;

  vizSlides.forEach((value, i) => {
    let slideTitle = "";
    let titleTag = value.querySelector(".carousel-title");

    if (titleTag) {
      slideTitle = titleTag.innerHTML;
    } else {
      slideTitle = `Frame ${i + 1}`;
    }

    value.slideTitle = slideTitle;

    if (i == currentState.currentPanel) {
      initialTitle = slideTitle;
      value.classList.add("active");
    }

    let buttonTemplate = document.createElement("button");
    buttonTemplate.setAttribute("data-bs-toggle", "tooltip");
    buttonTemplate.setAttribute("data-bs-placement", "top");
    buttonTemplate.setAttribute("data-bs-title", slideTitle);
    buttonTemplate.classList.add("vizSelectorButton");
    if (i == currentState.currentPanel) {
      buttonTemplate.classList.add("vizSelected");
    }

    buttonTemplate.name = i;

    buttonTemplate.addEventListener("click", switchCarouselSlide);

    vizSelector.appendChild(buttonTemplate);

    vizSelectors.push(buttonTemplate);
  });

  carouselElement.addEventListener("slide.bs.carousel", (e) => {
    switchVizSelector(String(e.to));
  });

  function switchCarouselSlide(e) {
    // Function that identifies which element has been clicked and
    // switching to that slide

    carousel.to(e.currentTarget.name);
    e.currentTarget.classList.add("vizSelected");

    switchVizSelector(e.currentTarget.name);
  }

  // Enabling Tooltips
  const tooltipTriggerList = document.querySelectorAll(
    '[data-bs-toggle="tooltip"]'
  );
  const tooltipList = [...tooltipTriggerList].map(
    (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
  );

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      document.addEventListener("click", (e) => {
        const tooltip = bootstrap.Tooltip.getInstance(e.target);
        if (tooltip) setTimeout(tooltip.hide(), 100);
      });
    },
    false
  );

  // Setting Initial Frame

  vizSelectorTitle.innerText = initialTitle;

  // Setting up Switch for AutoRotate

  const checkbox = document.getElementById("vizAutoRotateSwitchBox");
  checkbox.addEventListener("click", autoRotateOnCheck);
}

function switchVizSelector(index) {
  // Function to switch vizSelector to current slide
  vizSelectors.forEach((tmpVizSelector) => {
    if (tmpVizSelector.name === index) {
      tmpVizSelector.classList.add("vizSelected");
      vizSelectorTitle.innerText = tmpVizSelector.getAttribute("data-bs-title");
    } else {
      tmpVizSelector.classList.remove("vizSelected");
    }
  });

  currentState.currentPanel = index;
  changeURLSearchParam("panel", index);
}

/**
 * Switch Carousel to Slide by Number
 * @param {number} index
 */

export function switchCarouselSlideToIndex(index) {
  switchVizSelector(index);
  carousel.to(index);
}

function carouselAutoRotate() {
  let nextIndex = (currentState.currentPanel + 1) % vizSelectors.length;
  switchCarouselSlideToIndex(nextIndex);
}

function startAutoRotate() {
  currentState.carouselRotateIntervalID ??= setInterval(
    carouselAutoRotate,
    15000
  );
}

function clearAutoRotate() {
  clearInterval(currentState.carouselRotateIntervalID);
  currentState.carouselRotateIntervalID = null;
}

export function autoRotateOnCheck() {
  const checkbox = document.getElementById("vizAutoRotateSwitchBox");

  if (checkbox.checked == true) {
    startAutoRotate();
  } else {
    clearAutoRotate();
  }
}
